import(/* webpackMode: "eager", webpackExports: ["ClientOnlyScript"] */ "/root/projects/amazighgroupe/app/[locale]/script.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/projects/amazighgroupe/app/[locale]/TranslationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProgressBar","MyAlert"] */ "/root/projects/amazighgroupe/components/CommonElements.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/projects/amazighgroupe/components/navigation/bottomNavBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileHeader"] */ "/root/projects/amazighgroupe/components/navigation/MobileHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/projects/amazighgroupe/utils/auth_provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/projects/amazighgroupe/utils/DialogProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/projects/amazighgroupe/utils/DrawerProvider.tsx");
